import { clampSlugForKey } from './_uilm-key-internals';

/**
 * Build a UILM key for a template's title or description.
 *
 * Pathological slugs (longer than `MAX_SLUG_KEY_LENGTH`) are truncated
 * + hashed by `clampSlugForKey` so the resulting key still fits in the
 * 100-char UILM limit. Normal-length slugs pass through unchanged.
 *
 *   uilmKeyForTemplate('nda', 'title')                  → 'NDA_TITLE'
 *   uilmKeyForTemplate('employment-agreement', 'desc')  → 'EMPLOYMENT_AGREEMENT_DESC'
 *   uilmKeyForTemplate('studentAgreement', 'title')     → 'STUDENT_AGREEMENT_TITLE'
 */
export type TemplateKeyType = 'title' | 'desc';

export function uilmKeyForTemplate(templateSlug: string, type: TemplateKeyType): string {
  return `${clampSlugForKey(templateSlug)}_${type.toUpperCase()}`;
}
